import React, {useState, useEffect} from 'react';
import '../style.css';
import List from './case/list';
import FileUpload from './uploads/csv';
import Collapsible from './collapsible';
import {API} from '../api-service';
import {AdminStatus} from "./statuses"
import 'react-dropdown/style.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function Admin({cases, setCases, token, inverted}) {

  const [nurseList, loadNurseList] = useState([]);
  const len = Object.keys(AdminStatus).length

  useEffect( () => {
        const nursespl = new Array();
        API.getNurseList(token['pn-token'])
        .then(resp => resp.map(nurse => nursespl.push({
          'label': `${nurse.nurse_name} - ${nurse.area_assigned}, ${nurse.nurse_province} - ${nurse.num_cases} assigned`, 
          'value': nurse.nurse_name,
          'userid': nurse.user_id
        })))
        .then(() => loadNurseList(nursespl))
  },[cases])

  return (
      <div className='Layout'>
          {Object.keys(AdminStatus).map( (stat, i) => {
            return (
              <Collapsible key={i} title={`${AdminStatus[stat].label}`}>
                <div className='case headings'>
                  <h6 className='col head'>Reference<br/>Policy Number</h6>
                  <h6 className='col head'>Address</h6>
                  <h6 className='col head'>City/Town, Province</h6>
                  {AdminStatus[stat].key == AdminStatus.new.key?
                    <h6 className='col head'>Date Received</h6>:
                    AdminStatus[stat].key == AdminStatus.assigned.key?
                    <h6 className='col head'>Date Assigned</h6>:
                    AdminStatus[stat].key == AdminStatus.aptmade.key?
                    <h6 className='col head'>Appointment Date</h6>:
                    AdminStatus[stat].key == AdminStatus.aptresc.key?
                    <h6 className='col head'>Appointment Date</h6>:
                    AdminStatus[stat].key == AdminStatus.aptcomp.key?
                    <h6 className='col head'>Date of Appointment Completion</h6>:
                    AdminStatus[stat].key == AdminStatus.completed.key?
                    <h6 className='col head'>insurance Company</h6>:
                    <h6 className='col head'>Name</h6>
                  }
                  <span/>
                  <span/>
                  <span/>
                  
                </div>
                <List index={i} setCases={setCases} status={AdminStatus[stat]} cases={cases} inverted={inverted} nurseList={nurseList} token={token}/>
              </Collapsible>
            )
          })}

          <Collapsible title="Case Data">
            <FileUpload />
          </Collapsible>
      </div>
  );
}

export default Admin;
